import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import EmployerTestimonialCarousel from './EmployerTestimonialCarousel';
import EmployerSignupForm from '../EmployerSignupForm';
import peopleDiscussingImg from '../../../../assets/images/add-a-project-bold.svg';
import pioneeringActiveLogo from '../../../../assets/images/testimonials/pioneering-active.png';
import pioneeringInactiveLogo from '../../../../assets/images/testimonials/pioneering-inactive.png';
import cyclerionActiveLogo from '../../../../assets/images/testimonials/cyclerion-active.png';
import cyclerionInactiveLogo from '../../../../assets/images/testimonials/cyclerion-inactive.png';
import rhythmActiveLogo from '../../../../assets/images/testimonials/rhythm-active.png';
import rhythmInactiveLogo from '../../../../assets/images/testimonials/rhythm-inactive.png';
var employerTestimonials = function employerTestimonials() {
  var pioneering = {
    managerName: 'Alec Reynolds',
    managerTitle: 'SVP, Portfolio Strategy & Operations',
    body: 'Clora is a great service. They have identified a ' + 'number of experts for us. They know us and our ' + 'business well and work hard to understand the ' + 'talent we need, access their large network, ' + 'and quickly find the right match. ' + 'We have been impressed.',
    activeLogo: pioneeringActiveLogo,
    inactiveLogo: pioneeringInactiveLogo,
    logoHeight: 24,
    logoWidth: 125
  };
  var cyclerion = {
    managerName: 'Chris Wright',
    managerTitle: 'Former Chief Medical Officer',
    body: 'We have hired several excellent consultants for our ' + 'teams. The process has been easy, efficient and ' + 'quick in all cases.  [...] we found exactly the ' + 'right profiles for the areas where we needed ' + 'additional capacity and subject matter ' + 'expertise across a range of disciplines [...]. ' + 'Our consultants work seamlessly with our internal staff ' + 'and the culture fit has been exceptional.',
    activeLogo: cyclerionActiveLogo,
    inactiveLogo: cyclerionInactiveLogo,
    logoHeight: 30,
    logoWidth: 70
  };
  var rhythm = {
    managerName: 'Satej Bhandarkar',
    managerTitle: 'SVP, Program Management & Strategy',
    body: 'Our consultant has been great to work with at ' + 'every stage of this project and we couldn\'t be ' + 'more proud of the work she\'s been able to produce ' + 'for our team [...] We would be in a tough spot without her. ' + 'Thanks again for helping us find this valuable team member.',
    activeLogo: rhythmActiveLogo,
    inactiveLogo: rhythmInactiveLogo,
    logoHeight: 20,
    logoWidth: 80
  };
  return [pioneering, cyclerion, rhythm];
};
var renderEmployerTestimonials = function renderEmployerTestimonials() {
  return /*#__PURE__*/React.createElement("div", {
    className: "centered-testimonials-panel"
  }, /*#__PURE__*/React.createElement(EmployerTestimonialCarousel, {
    testimonials: employerTestimonials(),
    interval: 15000
  }));
};
var renderPeopleDiscussingImage = function renderPeopleDiscussingImage() {
  return /*#__PURE__*/React.createElement("img", {
    alt: "people discussing",
    className: "people-discussing d-none d-md-block",
    src: peopleDiscussingImg
  });
};
var referralPanel = function referralPanel(referrer, company) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: "hero-header registration-welcome-title"
  }, referrer, ' ', "wants you to meet Clora."), /*#__PURE__*/React.createElement("div", {
    className: "body-text-1 registration-welcome-body"
  }, "Your friend,", ' ', referrer, ", thinks you are a great fit for Clora. Join the platform, like", ' ', company, ", and start matching your on-demand project needs with talented life-science experts!"), renderPeopleDiscussingImage());
};
function EmployerSignupPanel(_ref) {
  var csrfToken = _ref.csrfToken,
    invitedEmail = _ref.invitedEmail,
    company = _ref.company,
    referralToken = _ref.referralToken,
    referrer = _ref.referrer,
    referrerCompany = _ref.referrerCompany,
    signInUrl = _ref.signInUrl,
    googleOmniauthUrl = _ref.googleOmniauthUrl,
    msOmniauthUrl = _ref.msOmniauthUrl,
    header = _ref.header,
    showReferralPanel = _ref.showReferralPanel,
    extraParams = _ref.extraParams,
    showTestimonials = _ref.showTestimonials,
    location = _ref.location,
    inviterId = _ref.inviterId,
    projectResourceId = _ref.projectResourceId;
  return /*#__PURE__*/React.createElement("div", {
    className: "employer-registration"
  }, /*#__PURE__*/React.createElement(Row, null, !(referrer && referralToken && referrerCompany) && /*#__PURE__*/React.createElement("div", {
    className: "quarter-circle-bottom-left d-none d-md-block"
  }), showReferralPanel && /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement("div", {
    className: "left-panel"
  }, referrer && referralToken && referrerCompany ? referralPanel(referrer, referrerCompany) : /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-block"
  }, ' ', renderEmployerTestimonials(), ' '))), /*#__PURE__*/React.createElement(Col, {
    xs: true,
    sm: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "employer-form"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "hero-header"
  }, header), /*#__PURE__*/React.createElement(EmployerSignupForm, {
    csrfToken: csrfToken,
    invitedEmail: invitedEmail,
    company: company,
    referralToken: referralToken,
    submitButtonText: "Sign Up as an Employer",
    signInUrl: signInUrl,
    location: location,
    googleOmniauthUrl: googleOmniauthUrl,
    msOmniauthUrl: msOmniauthUrl,
    extraParams: extraParams,
    inviterId: inviterId,
    projectResourceId: projectResourceId
  }), showTestimonials && /*#__PURE__*/React.createElement("div", {
    className: "mt-5 d-block d-md-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "quarter-circle-bottom-left"
  }), renderEmployerTestimonials())))));
}
EmployerSignupPanel.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  company: PropTypes.string,
  referralToken: PropTypes.string,
  referrer: PropTypes.string,
  referrerCompany: PropTypes.string,
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  header: PropTypes.string,
  showReferralPanel: PropTypes.bool,
  extraParams: PropTypes.shape({}),
  showTestimonials: PropTypes.bool,
  location: PropTypes.string,
  inviterId: PropTypes.string,
  projectResourceId: PropTypes.string
};
EmployerSignupPanel.defaultProps = {
  invitedEmail: null,
  company: null,
  referralToken: null,
  referrer: null,
  referrerCompany: null,
  header: 'Switch to the simplest way of hiring',
  showReferralPanel: true,
  extraParams: {},
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  showTestimonials: true,
  location: 'Registration Page',
  inviterId: null,
  projectResourceId: null
};
export default EmployerSignupPanel;